import { useEffect } from "react";

// @page es una regla global de impresión, no se puede limitar por selector/clase.
// Se inyecta y se retira del <head> según el ciclo de vida de cada página para que
// no compita con el @page que pida otro reporte montado en otro momento.
export function usePrintOrientation(orientation = "portrait") {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `@media print { @page { size: ${orientation}; } }`;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, [orientation]);
}
